/* eslint-disable @typescript-eslint/no-explicit-any */
import { useEffect } from 'react';

import { reportingTreeStore } from '@stores/reportingTreeStore';

interface TreeView<T> {
  children?: T[];
  reportPackageCode?: string;
  reportVersionCode?: string;
}

const recursiveFind = <T extends TreeView<T>>(
  data: T[],
  reportPackageCode: string,
  reportVersionCode: string,
): T[] | null => {
  for (const obj of data) {
    if (obj.reportPackageCode === reportPackageCode && obj.reportVersionCode === reportVersionCode) {
      return [obj];
    }
    if (obj.children && obj.children.length > 0) {
      const result = recursiveFind(obj.children, reportPackageCode, reportVersionCode);
      if (result) {
        return [{ ...obj }, ...result];
      }
    }
  }
  return null;
};

// Раскрываем дерево до отчета и сам отчет при переходе из другой секции. Сейчас работает для реестра публикаций (PublicationRegister) и контроля данных (DataControl, уровень ControlLevel)
export const useExpandedTreeFromAnotherRouter = (onSelect: (props: any, data: any) => void): void => {
  const { setStateTree, reportingTree } = reportingTreeStore;

  // TODO несколько раз вызывается запрос на получение организации, подумать об оптимизации
  useEffect(() => {
    const storage = localStorage.getItem('expandedTreeFromAnotherRouter');
    const parseStorage = storage ? JSON.parse(storage) : null;

    if (parseStorage && reportingTree.length) {
      const { reportPackageCode, reportVersionCode } = parseStorage;

      if (reportPackageCode && reportVersionCode) {
        const keys =
          recursiveFind(reportingTree, parseStorage.reportPackageCode, parseStorage.reportVersionCode)?.map(
            (item) => item.id,
          ) ?? [];

        const last = keys.pop(); // удаляем последний элемент, чтобы в expandedKeys не попал сам узел по которому будет открываться отчет

        setStateTree({ expandedKeys: keys });
        onSelect({}, { node: { ...parseStorage, key: last } });
      }

      localStorage.removeItem('expandedTreeFromAnotherRouter');
    }
  }, [onSelect, reportingTree, setStateTree]);
};
